import axios, {AxiosResponse} from 'axios'
import {ID, Response} from '../../../../../../_metronic/helpers'
import {Chat, ChatQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL
const USER_URL = `${API_URL}/users`
const STATUS_UPDATE_URL = `${API_URL}/users/update-status`
const GET_CHATS_URL = `${API_URL}/chat`
const SEND_CHATS_URL = `${API_URL}/chat/send`

const ADMIN_AUTH = `${API_URL}/admin/auth/update/password`
const USERS_URL = `${API_URL}/auth/create`

const getChats = (query: string,companyId:string): Promise<ChatQueryResponse> => {
  return axios
    .get(`${GET_CHATS_URL}/${companyId}?${query}`)
    .then((d: AxiosResponse<ChatQueryResponse>) => d.data)
}

const getUserById = (id: ID): Promise<Chat | undefined> => {
  return axios
    .get(`${GET_CHATS_URL}/${id}`)
    .then((response: AxiosResponse<Response<Chat>>) => response.data)
    .then((response: Response<Chat>) => response.data)
}

const createUser = (user: Chat): Promise<Chat | undefined> => {
  return axios
    .post(USERS_URL, user)
    .then((response: AxiosResponse<Response<Chat>>) => response.data)
    .then((response: Response<Chat>) => response.data)
}

const updateUserDetail = (user: Chat): Promise<Chat | undefined> => {
  return axios
    .patch(`${GET_CHATS_URL}/${user._id}`, user)
    .then((response: AxiosResponse<Response<Chat>>) => response.data)
    .then((response: Response<Chat>) => response.data)
}

const updateUser = (user: Chat): Promise<Chat | undefined> => {
  return axios
    .patch(`${STATUS_UPDATE_URL}/${user._id}`, user)
    .then((response: AxiosResponse<Response<Chat>>) => response.data)
    .then((response: Response<Chat>) => response.data)
}

const updatePassword = (user: Chat): Promise<Chat | undefined> => {
  return axios
    .post(`${ADMIN_AUTH}/${user._id}`, user)
    .then((response: AxiosResponse<Response<Chat>>) => response.data)
    .then((response: Response<Chat>) => response.data)
}

const deleteUser = (userId: ID): Promise<void> => {
  return axios.delete(`${USER_URL}/${userId}`).then(() => {})
}

const sendChat = (chatID: ID, email: any, companyId: any) => {
  return axios
    .get(`${SEND_CHATS_URL}/${companyId}?id=${chatID}&email=${email}`)
    .then((response: AxiosResponse<Response<any>>) => response.data)
    .then((response: any) => response.data)
}

const deleteSelectedUsers = (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.delete(`${USER_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

const deleteChat = (chatID: ID, companyId : string): Promise<void> => {
  return axios.delete(`${GET_CHATS_URL}/${companyId}/${chatID}`).then(() => {})
}

const deleteMultipleChats = (data: any,companyId : string): Promise<void> => {
  const apiData: any = {
    ids: data,
  };
  return axios
    .delete(`${GET_CHATS_URL}/delete-multiple/${companyId}`, {
      data: apiData,
    })
    .then((response: any) => {
      console.log(response);
    })
    .catch((error: any) => {
      console.log(error);
    });
}


export {getChats, deleteUser, deleteChat, sendChat, deleteMultipleChats}
